// ==============================|| OVERRIDES - TABLE CELL ||============================== //

export default function TableCell(theme) {
  return {
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontFamily: theme.typography.fontFamily,
          fontSize: theme.typography.customFontSize[3],
          color: theme.palette.primary.greyPrimary,
        },
      }
    }
  };
}
